import { ApplicationConfig, provideZoneChangeDetection } from "@angular/core"
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async"
import { provideRouter } from "@angular/router"
import Aura from "@primeng/themes/aura"
import { AbstractSecurityStorage, DefaultLocalStorageService, provideAuth } from "angular-auth-oidc-client"
import { routes } from "./app.routes"
import { providePrimeNG } from "primeng/config"
import { MessageService, ConfirmationService } from "primeng/api"
import { provideHttpClient } from "@angular/common/http"
import { provideAngularSvgIcon } from "angular-svg-icon"
import { authConfig } from "./auth/auth.config"
import { provideTranslateService } from "@ngx-translate/core"
import { provideTranslateHttpLoader } from "@ngx-translate/http-loader"

export const appConfig: ApplicationConfig = {
	providers: [
		provideHttpClient(),
		provideRouter(routes),
		provideAnimationsAsync(),
		providePrimeNG({
			theme: {
				preset: Aura,
				options: {
					darkModeSelector: ".dark",
					cssLayer: {
						name: "primeng",
						order: "theme, base, primeng"
					}
				}
			}
		}),
		provideZoneChangeDetection({ eventCoalescing: true }),
		provideAngularSvgIcon(),
		provideAuth(authConfig),
		{
			provide: AbstractSecurityStorage,
			useClass: DefaultLocalStorageService
		},
		// PrimeNG services provided application-wide so Toast/Confirm use a single instance
		MessageService,
		ConfirmationService,
		provideTranslateService({
			loader: provideTranslateHttpLoader({
				prefix: "/assets/i18n/",
				suffix: ".json"
				// opzioni aggiuntive se vuoi:
				// enforceLoading: true,  // aggiunge timestamp per evitare cache
				// useHttpBackend: false  // se vuoi bypassare gli interceptor HTTP
			}),
			fallbackLang: "it",
			lang: "it"
		})
	]
}
